import React, { useEffect, useState } from 'react';
import { attractionTaxonomyStaticData } from './attractionTaxonomyStaticData';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';

interface TreeFilterType {
  key: string;
  value: string;
  label: string;
  children?: TreeFilterType[] | undefined;
}

const useAttractionTreeFilters = () => {
  const { general: t, attractions: t_attractions } = useSelector(
    (state: RootState) => state.config.translations
  );
  const [treeFilter, setTreeFilter] = useState<TreeFilterType[] | null>(null);

  useEffect(() => {
    function parseData(arr: any[]) {
      const result: TreeFilterType[] = [];
      let usedSlugs: Record<string, boolean> = {};

      arr.forEach((item) => {
        let children: TreeFilterType[] = [];
        if (item.children && item.children.length > 0) {
          children.push(...parseData(item.children));
        }
        // if (usedSlugs[item.slug]) {
        //   return;
        // }

        let el: TreeFilterType = {
          key: item.slug,
          value: item.slug,
          label: t_attractions[item.slug] ?? item.localizedName,
          children: children?.length ? children : undefined,
        };
        // usedSlugs[item.slug] = true;

        result.push(el);
      });

      return result;
    }
    setTreeFilter(parseData(attractionTaxonomyStaticData.taxonomy_tree));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return treeFilter;
};

export default useAttractionTreeFilters;
